"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _reactRedux = require("react-redux");
var _redux = require("redux");
var _exchangeReactHooks = require("@mulesoft/exchange-react-hooks");
var _exchangeUiPortalsStore = require("@mulesoft/exchange-ui-portals-store");
var _Actions = _interopRequireDefault(require("./Actions"));
var mapStateToProps = function mapStateToProps(state, _ref) {
  var _assetTypesConfigurat, _assetTypesConfigurat2;
  var asset = _ref.asset,
    getPath = _ref.router.getPath,
    isDraft = _ref.isDraft,
    isEdit = _ref.isEdit,
    pagePath = _ref.pagePath,
    config = _ref.config,
    assetTypesConfiguration = _ref.assetTypesConfiguration;
  var type = asset.type,
    groupId = asset.groupId,
    assetId = asset.assetId,
    version = asset.version,
    versionGroup = asset.versionGroup,
    minorVersion = asset.minorVersion;
  var gav = {
    groupId: groupId,
    assetId: assetId,
    version: version
  };
  var editURL = getPath('pageEdit', {
    type: type,
    groupId: groupId,
    assetId: assetId,
    version: version,
    minorVersion: minorVersion,
    versionGroup: versionGroup,
    pagePath: config.defaultPageName
  });
  var portal = _exchangeUiPortalsStore.selectors.selectPortal(state, {
    groupId: groupId,
    assetId: assetId,
    version: version,
    isDraft: isDraft
  });
  var profile = _exchangeUiPortalsStore.selectors.selectProfile(state);
  var canEdit = _exchangeUiPortalsStore.selectors.selectCanEditAsset(state, gav);
  var isPortalReArchitectureEnabled = _exchangeUiPortalsStore.selectors.selectIsPIRAEnabled(state);
  var canAddVersion = canEdit && isPortalReArchitectureEnabled && !!((_assetTypesConfigurat = assetTypesConfiguration[asset.type]) !== null && _assetTypesConfigurat !== void 0 && (_assetTypesConfigurat2 = _assetTypesConfigurat.form) !== null && _assetTypesConfigurat2 !== void 0 && (_assetTypesConfigurat2 = _assetTypesConfigurat2.call(_assetTypesConfigurat, {
    profile: profile,
    config: config,
    latestAsset: asset
  })) !== null && _assetTypesConfigurat2 !== void 0 && (_assetTypesConfigurat2 = _assetTypesConfigurat2.flows) !== null && _assetTypesConfigurat2 !== void 0 && _assetTypesConfigurat2.length);
  return {
    asset: asset,
    isMinorDeprecated: _exchangeUiPortalsStore.selectors.selectIsAssetMinorDeprecated(state, asset),
    canEdit: canEdit,
    canAdmin: _exchangeUiPortalsStore.selectors.selectCanAdminAsset(state, gav),
    canAddVersion: canAddVersion,
    hasUnpublishedChanges: (portal === null || portal === void 0 ? void 0 : portal.draftStatus) !== 'PUBLISHED',
    isDraft: isDraft,
    isEdit: isEdit,
    editURL: editURL,
    isPortalReArchitectureEnabled: isPortalReArchitectureEnabled,
    isPublishing: _exchangeUiPortalsStore.selectors.selectIsPublishing(state),
    pagePath: pagePath
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch, _ref2) {
  var _ref2$router = _ref2.router,
    getPath = _ref2$router.getPath,
    push = _ref2$router.push;
  return {
    onPublish: function () {
      var _onPublish = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(payload) {
        var pageURL;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return dispatch(_exchangeUiPortalsStore.actions.publishPortalDraft(payload));
            case 2:
              pageURL = getPath('page', payload);
              push(pageURL);
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function onPublish(_x) {
        return _onPublish.apply(this, arguments);
      }
      return onPublish;
    }()
  };
};
var ConnectedActions = (0, _redux.compose)(_exchangeReactHooks.withAnalytics, _exchangeReactHooks.withRouter, _exchangeReactHooks.withAssetTypesConfiguration, _exchangeReactHooks.withConfig, (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)
// @ts-ignore
)(_Actions.default);
var _default = exports.default = ConnectedActions;
//# sourceMappingURL=Actions.container.js.map